import { render, staticRenderFns } from "./ExternalBookingSummary.vue?vue&type=template&id=60ff0a81"
import script from "./ExternalBookingSummary.vue?vue&type=script&lang=js"
export * from "./ExternalBookingSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports